import { render } from "./FaqView.vue?vue&type=template&id=33dc4638&scoped=true&ts=true"
import script from "./FaqView.vue?vue&type=script&lang=ts"
export * from "./FaqView.vue?vue&type=script&lang=ts"

import "./FaqView.vue?vue&type=style&index=0&id=33dc4638&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dc4638"]])

export default __exports__